import { Typography } from "@mui/material";
import {
  AppBar,
  Box,
  Button,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";

import React from "react";

export default function DeliveryTime({ setsubDetails, subDetails }) {
  const [selectedValue, setSelectedValue] = React.useState(false);
  console.log(selectedValue);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  const handleSetRadioValue = (value) => {
    setsubDetails({ ...subDetails, deliveryTime: value });
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  return (
    <>
      <Box sx={{ width: "100%",  }}>
        <Box>
          <Typography
            sx={{ fontSize: "20px", fontWeight: "600", pb: "8px", pt: "24px" }}
          >
            Delivery Time
          </Typography>
        </Box>

        <Box
          sx={{
            // border: "1px solid green",
            width: "100%",
          }}
        >
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    xl: "row",
                    lg: "row",
                    md: "row",
                    sm: "row",
                    xs: "column",
                  },
                  // width: { lg: "fit-content", md: "100%", sm: "110%", xs: "135%" },
                  // border: "1px solid red",
                }}
              >
                <Box
                  fullWidth
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid #E1E1E6",
                    borderRadius: "4px",
                    borderRadius: "4px",
                    width: "100%",
                    // border:"1px solid blue",
                    // width: {
                    //   lg: "337px",
                    //   md: "300px",
                    //   sm: "300px",
                    //   xs: "300px",
                    // },
                    // width: "100%",
                    height: "94px",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ display: "flex", width: "100%" }}>
                      <Box pl="10px">
                        {/* <Radio {...controlProps("c")} color="success" /> */}
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          onClick={(e) => {
                            setsubDetails({
                              ...subDetails,
                              deliveryTime: "10.00 AM - 01.00 PM",
                            });
                          }}
                        />
                      </Box>

                      <Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "20px",
                                md: "20px",
                                sm: "18px",
                                xs: "14px",
                              },
                              fontWeight: "600",
                              width: "160px",
                            }}
                          >
                            Morning Delivery
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "16px",
                                md: "16px",
                                sm: "14px",
                                xs: "12px",
                              },
                              fontWeight: "400",
                              color: "#545359",
                            }}
                          >
                            10.00 AM - 01.00 PM
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  fullWidth
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid #E1E1E6",
                    borderRadius: "4px",
                    // width: {lg: "337px", md: "300px", sm: "300px", xs: "300px"},
                    // width: {
                    //   lg: "337px",
                    //   md: "300px",
                    //   sm: "300px",
                    //   xs: "300px",
                    // },
                    height: "94px",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                    justifyContent: "center",
                    ml: {
                      xl: "24px",
                      lg: "24px",
                      md: "24px",
                      sm: "24px",
                      xs: "0px",
                    },
                    width: "100%"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      <Box pl="10px">
                        {/* <Radio {...controlProps("c")} color="success" /> */}
                        <FormControlLabel
                          value="4"
                          control={<Radio />}
                          onClick={(e) => {
                            setsubDetails({
                              ...subDetails,
                              deliveryTime: "04.00 PM - 06.00PM",
                            });
                          }}
                        />{" "}
                      </Box>

                      <Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "20px",
                                md: "20px",
                                sm: "18px",
                                xs: "14px",
                              },
                              fontWeight: "600",
                              width: "160px",
                            }}
                          >
                            Evening Delivery
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "16px",
                                md: "16px",
                                sm: "14px",
                                xs: "12px",
                              },
                              fontWeight: "400",
                              color: "#545359",
                            }}
                          >
                            04.00 PM - 06.00PM
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </>
  );
}
